import logoUrl from '../../assets/logo-dispenser.png';

export const C = {
    // Paleta alineada al logo: negro elegante + rojo acento + dorado detalles
    navy:       [42,  42,  46 ],   // Charcoal premium — headers tabla, títulos, cajas
    navyLight:  [70,  70,  75 ],   // Charcoal claro
    red:        [193, 42,  30 ],   // Rojo marca — línea divisora, acentos puntuales
    redLight:   [254, 243, 241],
    white:      [255, 255, 255],
    grayBg:     [246, 246, 247],
    grayText:   [85,  85,  90 ],
    grayBorder: [210, 210, 215],
    grayZebra:  [240, 240, 242],
    grayLight:  [248, 248, 249],
    dark:       [38,  38,  38 ],   // Texto principal
    green:      [31,  157, 85 ],
    greenLight: [240, 253, 244],
    gold:       [180, 120, 0  ],   // Solo para detalles pequeños
    goldLight:  [255, 248, 230],
};

export const LOGO_URL = logoUrl;
export const M          = 14;
export const PAGE_W     = 210;
export const PAGE_H     = 297;
export const FOOTER_SAFE = 22;
export const CONTENT_W  = PAGE_W - M * 2;

export const HEADER_H = {
    // 18-oct-2026: cabecera nueva (logo + título); la línea roja queda en 31 mm
    normal:  34,
    compact: 33,
};

export const T = {
    xxl:   22,
    xl:    16,
    lg:    13,
    md:    10,
    sm:    8.5,
    xs:    7.5,
    xxs:   6.5,
    label: 6,
};

// WhatsApp de la empresa: sale en todos los PDF, lo genere quien lo genere
export const WHATSAPP_EMPRESA = '11 6608-2608';

export function getEmpresa() {
    try {
        // Datos editables desde Más › Configuración (si no hay, quedan los de siempre).
        // 18-oct-2026: el teléfono y el WhatsApp son siempre los de la empresa, nunca los del usuario
        // que genera el PDF (si lo generaba un técnico, salía su número personal).
        const d = JSON.parse(localStorage.getItem('empresa_datos') || '{}');
        const base = {
            nombre:           'DISPENSER LA TIENDA',
            eslogan:          'SERVICIO TÉCNICO ESPECIALIZADO',
            telefono:         '',
            whatsapp:         WHATSAPP_EMPRESA,
            web:              'www.dispenserlatienda.com.ar',
            email:            'info@dispenserlatienda.com.ar',
            instagram:        '@dispenserlatienda',
            tiktok:           '@dispenserlatienda',
            condicionesPDF:   localStorage.getItem('empresa_condiciones_pdf') || '',
        };
        Object.keys(d).forEach(k => { if (d[k]) base[k] = d[k]; });
        return base;
    } catch {
        return {
            nombre: 'DISPENSER LA TIENDA', eslogan: 'SERVICIO TÉCNICO ESPECIALIZADO',
            telefono: '', whatsapp: WHATSAPP_EMPRESA, web: 'www.dispenserlatienda.com.ar', email: 'info@dispenserlatienda.com.ar', instagram: '@dispenserlatienda', tiktok: '@dispenserlatienda', condicionesPDF: '',
        };
    }
}

export function procesarFecha(f) {
    try {
        if (!f) return new Date().toLocaleDateString('es-AR');
        const d = new Date(f.includes('T') ? f : `${f}T12:00:00`);
        return isNaN(d.getTime()) ? new Date().toLocaleDateString('es-AR') : d.toLocaleDateString('es-AR');
    } catch { return new Date().toLocaleDateString('es-AR'); }
}

export function generarNroDocumento(prefijo, fecha, tecnico) {
    const p = (fecha || '').split('/');
    const ddmm = p.length >= 2 ? `${p[0].padStart(2,'0')}${p[1].padStart(2,'0')}` : '0101';
    const palabras = (tecnico || 'TEC').trim().split(/\s+/);
    const ini = palabras.length >= 2
        ? (palabras[0][0] + palabras[1][0]).toUpperCase()
        : palabras[0].substring(0, 3).toUpperCase();
    const key = `pdf_counter_${prefijo}_${ddmm}`;
    const n = (parseInt(localStorage.getItem(key) || '0')) + 1;
    localStorage.setItem(key, n.toString());
    return `${prefijo}-${ddmm}-${ini}-${String(n).padStart(2,'0')}`;
}
